module.exports = __webpack_public_path__ + "assets/app-store-en.svg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/stores/app-store-en.svg
// module id = 435
// module chunks = 19